export const fonts = {
  display: `'Space Grotesk', 'Geist', sans-serif`,
  heading: `'Geist', 'Inter', sans-serif`,
  body: `'Geist', 'Inter', sans-serif`,
  mono: `'JetBrains Mono', monospace`,
};

export const fontSizes = {
  xs: '12px',
  sm: '13px',
  md: '13px',
  lg: '14px',
  xl: '16px',
  '2xl': '18px',
  '3xl': '24px',
  '4xl': '24px',
  '5xl': '24px',
  '6xl': '24px',
};

export const lineHeights = {
  none: '1',
  shorter: '16px',
  short: '20px',
  base: '20px',
  tall: '26px',
  taller: '30px',
};

export const fontWeights = {
  hairline: 400,
  thin: 400,
  light: 400,
  normal: 400,
  medium: 500,
  semibold: 500,
  bold: 500,
  extrabold: 500,
  black: 500,
};

export const letterSpacings = {
  tighter: '-0.15px',
  tight: '-0.15px',
  normal: '-0.15px',
  wide: '-0.15px',
  wider: '-0.15px',
  widest: '-0.15px',
};
